import React, { useEffect, useState } from 'react'
import { AnimalDetails } from '../components/AnimalDetails'
import { useGetAnimalById } from 'src/hooks/api/animal'
import { useNavigate } from 'react-router-dom'
import ROUTES from 'src/constants/routes'

interface IUseAnimalDetailsModal {
  id: string | undefined
}
export const useAnimalDetailsModal = ({ id }: IUseAnimalDetailsModal) => {
  const navigate = useNavigate()

  const [isOpen, setIsOpen] = useState(false)
  const { data: animalDetails, isLoading, isError } = useGetAnimalById(id!)

  const isRemoved = animalDetails?.acao === 'Removido'

  const handleOpenModal = () => {
    setIsOpen(true)
  }

  const handleCloseModal = () => {
    navigate(`${ROUTES.ANIMAL.ROOT}`, { replace: true })
    setIsOpen(false)
  }

  useEffect(() => {
    if (id) {
      handleOpenModal()
    }
  }, [id])

  return {
    handleOpenModal,
    handleCloseModal,
    modal: (
      <AnimalDetails
        isOpen={isOpen}
        data={animalDetails}
        handleOpenModal={handleOpenModal}
        handleCloseModal={handleCloseModal}
        isLoading={isLoading}
        isNotFound={isRemoved || isError}
      />
    )
  }
}
